var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5C16 3.35786 12.6421 0 8.5 0C4.35786 0 1 3.35786 1 7.5C1 11.2434 3.74263 14.3462 7.32812 14.9089V9.66797H5.42383V7.5H7.32812V5.84766C7.32812 3.96797 8.44785 2.92969 10.161 2.92969C10.9813 2.92969 11.8398 3.07617 11.8398 3.07617V4.92188H10.8941C9.9625 4.92188 9.67188 5.50005 9.67188 6.09375V7.5H11.752L11.4194 9.66797H9.67188V14.9089C13.2574 14.3462 16 11.2434 16 7.5Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4194 9.66797L11.752 7.5H9.67188V6.09375C9.67188 5.50063 9.9625 4.92188 10.8941 4.92188H11.8398V3.07617C11.8398 3.07617 10.9816 2.92969 10.161 2.92969C8.44785 2.92969 7.32812 3.96797 7.32812 5.84766V7.5H5.42383V9.66797H7.32812V14.9089C8.10465 15.0304 8.89535 15.0304 9.67188 14.9089V9.66797H11.4194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.65facfcfed808392b9f20ecaf66522c3.svg";
export { ForwardRef as ReactComponent };